import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryUpdateFailedAction = {
	type: 'BENEFICIARY_UPDATE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryUpdateFailedAction => ({
	type: 'BENEFICIARY_UPDATE_FAILED',
	payload,
});
